import BagIcon from "./BagIcon";
import FolderUserIcon from "./FolderUserIcon";
import React, { Component } from "react";
import TimerIcon from "./TimerIcon";
import ChartIcon from "./ChartIcon";
import ShoppingCartIcon from "./ShoppingCartIcon";
import DocumentIcon from "./DocumentIcon";
import MonitorIcon from "./MonitorIcon";
import PiggyBankIcon from "./PiggyBankIcon";
import SettingIcon from "./SettingIcon";
import ContractIcon from "./ContractIcon";
import FlatIcon from "./FlatIcon";
import ProductIcon from "./ProductIcon";
import DecentralizeIcon from "./DecentralizeIcon";
import NotificationIcon from "./NotificationIcon";
import ConfigurationIcon from "./ConfigurationIcon";
import ManageIcon from "./ManageIcon";
import KpiIcon from "./KpiIcon";
import ReportIcon from "./ReportIcon";
import DashBoardIcon from "./DashBoardIcon";
import Icon01 from "./Icon01";
import Icon02 from "./Icon02";
import Icon03 from "./Icon03";
import Icon04 from "./Icon04";
import ProductIcon1 from "./Product";
import { TemplateIcon } from "./TemplateIcon";
import CategoryIcon from "./CategoryIcon";

export const Icons = {
  BagIcon: <BagIcon />,
  FolderUserIcon: <FolderUserIcon />,
  TimerIcon: <TimerIcon />,
  ChartIcon: <ChartIcon />,
  ShoppingCartIcon: <ShoppingCartIcon />,
  DocumentIcon: <DocumentIcon />,
  MonitorIcon: <MonitorIcon />,
  PiggyBankIcon: <PiggyBankIcon />,
  SettingIcon: <SettingIcon />,
  ProductIcon1: <ProductIcon1 />,
  TemplateIcon: <TemplateIcon />,
  CategoryIcon: <CategoryIcon />,

  Contract: <ContractIcon />,
  Flat: <FlatIcon />,
  Products: <ProductIcon />,
  Decentralize: <DecentralizeIcon />,
  Notification: <NotificationIcon />,
  Configuration: <ConfigurationIcon />,
  Manage: <ManageIcon />,
  KPI: <KpiIcon />,
  Report: <ReportIcon />,
  Dashboard: <DashBoardIcon />,
  Icon01: <Icon01 />,
  Icon02: <Icon02 />,
  Icon03: <Icon03 />,
  Icon04: <Icon04 />,
};
